import React, { FocusEventHandler } from 'react';
import { GenericInputProps } from 'shared/types/commonPropTypes';

type TextWidgetProps = {
  placeholder?: string;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  readOnly?: boolean;
};

export const TextWidget = (props: GenericInputProps & TextWidgetProps) => {
  const { value, className, placeholder, onBlur, label } = props;

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange({ val: e.target.value });
  };

  return (
    <div className={`${className} ${label ? 'mt-2 w-full' : ''}`} id={props.option?.id}>
      {label && <div className={'text-ev-navy-blue font-bold mb-2'}>{label}</div>}
      <textarea
        className={`highed-field-input ${className}`}
        onChange={onChange}
        placeholder={placeholder || ''}
        onBlur={onBlur}
        readOnly={props?.readOnly}
        value={(value ?? '') as string}
      />
    </div>
  );
};

export default TextWidget;
